import { Injectable } from '@angular/core';
import { DemoDataService } from './demo-data.service';

/**
 * Auth Service - Demo Mode
 * 
 * This service now uses DemoDataService instead of making HTTP calls.
 * All authentication endpoints are replaced with demo data.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private demoDataService: DemoDataService) { }

  checkUserStatus(email: string): Promise<any> {
    return this.demoDataService.checkUserStatus(email);
  }

  verifyCredentials(email: string, password: string): Promise<any> {
    return this.demoDataService.verifyCredentials(email, password);
  }

  verifyAzureUser(handshakeToken: string): Promise<any> {
    return this.demoDataService.verifyAzureUser(handshakeToken);
  }

  sendVerification(handshakeToken: string, channel: 'email' | 'sms'): Promise<any> {
    return this.demoDataService.sendVerification(handshakeToken, channel);
  }

  verifyOtp(handshakeToken: string, code: string): Promise<any> {
    return this.demoDataService.verifyOtp(handshakeToken, code);
  }

  updatePhone(handshakeToken: string, phoneNumber: string, updateMonday: boolean = false): Promise<any> {
    return this.demoDataService.updatePhone(handshakeToken, phoneNumber, updateMonday);
  }

  skipSmsActivation(handshakeToken: string): Promise<any> {
    return this.demoDataService.skipSmsActivation(handshakeToken);
  }

  requestPasswordReset(email: string): Promise<any> {
    return this.demoDataService.requestPasswordReset(email);
  }

  verifyPasswordReset(email: string, verificationCode: string, newPassword: string): Promise<any> {
    return this.demoDataService.verifyPasswordReset(email, verificationCode, newPassword);
  }
}
